import React, { Component } from 'react';
import { WatchlistIndividualRecord, WatchlistModel } from '../../../domain/watchlist/WatchlistDomains';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistImageComponent extends Component<Props> {
  render() {
    if (this.getImages() == undefined || this.getImages().length == 0) {
      return;
    }
    return (
      <div className={'flex flex-col gap-y-2 mt-10'}>
        <div className={'bg-[#F2F4F7] w-full h-full rounded py-2 px-4 mt-2'}>
          <span className={'text-f-black-2 text-md'}>{LanguageUtil.get({ id: 'common.label.images', defaultMessage: 'Images' })}</span>
        </div>
        <div className={'h-full w-full overflow-x-scroll pt-2'}>
          <div className={'flex gap-x-2'}>
            {this.getImages().map((data, index) => {
              return (
                <img
                  src={data['image']}
                  alt='image'
                  key={index}
                  onClick={() => window.open(data['image'], '_blank')}
                  className={'w-[120px] h-[140px] cursor-pointer border flex justify-center items-center rounded-xl bg-[#EFF2FE] object-cover'}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  private getImages = () => {
    const { selectedResponse } = this.props;
    const flattenedArray: any[] = selectedResponse?.map((value) => {
      return (value.watchlistRecord as WatchlistIndividualRecord).images?.map((image) => {
        return {
          image,
          watchlistId: value.watchlistId,
          source: value.watchlistRecord.source,
        };
      });
    });
    return [].concat(...flattenedArray);
  };
}

interface Props {
  selectedResponse: WatchlistModel[];
}

export default WatchlistImageComponent;
